//====================================================================================================
//	単位変更処理 -> AdobeXD 24ページ
//	作成日:2022/08/26		最終更新日:2022/08/26
//	作成者:GFTD天神-徳渕	最終更新者:GFTD天神-徳渕
//====================================================================================================

import React from 'react';
import InputListLabel from '../../../../common/tenjin_tokubuchi/input_table_label/InputTableLabel';
import style from "./Label.module.css";

const CaseNumLabel = ()=> {
    return (
        <InputListLabel style={`${style.label}`} label={"ケース数"} />
    );
}

export default CaseNumLabel;